<template>
  <Popover
    ref="popover"
    :trigger="trigger"
    :tag="tag"
    :visible-arrow="true"
    :disabled="disabled"
    :placement="placement"
    :tooltip="true"
    :offset="offset"
    :stop-propagation="false"
    :append-to-body="appendToBody"
    :boundaries-selector="boundariesSelector"
    :delay="delay"
    :has-external-control="hasExternalControl"
    :popper-extra-class="popperExtraClass"
  >
    <template #title>
      <slot name="text" />
    </template>
    <template #body>
      <slot v-if="$slots.body" name="body"/>
      <div v-html="shortTitle"></div>
    </template>
  </Popover>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { shortText } from '../../helpers/text-helper'
const CONTAINER_SELECTOR = '.data-containers'
import Popover from "./Popover.vue";
type Placement ='auto' | 'auto-start' | 'auto-end' | 'top' | 'top-start' | 'top-end' | 'bottom' |
'bottom-start' | 'bottom-end' | 'right' | 'right-start' | 'right-end' | 'left' | 'left-start' | 'left-end'

type Props = {
  placement?: Placement,
  offset?: [number | null | undefined, number | null | undefined],
  delay?: number,
  trigger?: 'hover' | 'click',
  text?: string | number,
  disabled?: boolean,
  maxLength?: number,
  boundariesSelector?: string,
  tag?: 'span' | 'div',
  appendToBody?: boolean,
  hasExternalControl?: boolean,
  popperExtraClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  placement: 'auto',
  offset: () => [0, 12],
  delay: 0,
  trigger: 'hover',
  text: '',
  disabled: false,
  maxLength: 360,
  boundariesSelector: CONTAINER_SELECTOR,
  tag: 'span',
  hasExternalControl: false,
  appendToBody: false,
  popperExtraClass: ''
})

const shortTitle =  computed(() => {
  if (!props.text) {
      return ''
    }
    return shortText(props.text.toString(), props.maxLength)
})

const popover = ref<InstanceType<typeof Popover> | null>(null)

function showPopper() {
  popover.value?.showPopper()
}

function hidePopper() {
  popover.value?.hidePopper()
}

function updatePopper() {
  popover.value?.updatePopper()
}

defineExpose({
  showPopper,
  hidePopper,
  updatePopper
})
</script>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 99999;

  &.popover {
    .popover-inner {
      background: white;
      color: black;
      padding: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
